import { render, staticRenderFns } from "./TestSendSmsEmail.vue?vue&type=template&id=7a89c53c&scoped=true"
import script from "./TestSendSmsEmail.vue?vue&type=script&lang=js"
export * from "./TestSendSmsEmail.vue?vue&type=script&lang=js"
import style0 from "./TestSendSmsEmail.vue?vue&type=style&index=0&id=7a89c53c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a89c53c",
  null
  
)

export default component.exports